var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clubVersion === 'v2')?_c('CommentV2'):_c('div',{staticClass:"container-grid2"},[_c('div',{staticClass:"containerx"},[_c('div',{staticClass:"row"},[_c('Comment')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }